import { transformServiceResponse } from '../../../components/sections/owners-osb/osb-service-adapters/dealer-services-adapter';
import {
    DealerServices,
    DealerServicesArray,
} from '../../../models/osb-model/osb-dealerservice-info';
import { DealerServicesResponse } from '../../../models/osb-model/osb-service-step';
import { VehicleData } from '../../../models/osb-model/osb-vehicle-step';
import { OSBAPIResponse } from '../service-orchestration/service-adapter';
import {
    ErrorResponse,
    transformErrorResponse,
} from '../../../components/sections/owners-osb/osb-utils';
import { OSBApiService } from '../service-orchestration/osb-api-service';
import { OSB_API_PATH } from '../../../constants';
import { Bookable } from '../../../hooks/owners-osb/use-all-osb-state';
import { OSBStep } from '../../../models/osb-model/osb-step';
import { ExtractValueType } from '../../../components/sections/owners-osb/osb-bookable-utils';

export type DealerServiceAPIResponse = {
    value: {
        dealerServices: DealerServices;
    };
};

export class OSBDealerServicesClient {
    public getServicesList(args: {
        dealerCode?: string;
        vehicleData?: VehicleData;
        vouchers?: string[];
        bookingReferenceNumber?: string;
        serviceDeliveryType?: string;
        requestSourceType?: string;
        bookable: Bookable;
        DSLAPIVersion: ExtractValueType<OSBStep, 'DSLAPIVersion'>;
    }) {
        return this.getByPostServiceList(args.bookable);
    }

    public getByPostServiceList(bookable: Bookable) {
        return new Promise<OSBAPIResponse<DealerServicesArray>>(
            (resolve, reject) => {
                const transformedResponse: OSBAPIResponse<DealerServicesArray> = {
                    value: {} as DealerServicesArray,
                    responseError: {} as ErrorResponse,
                };
                new OSBApiService()
                    .postServiceAPIOnDealerCode<
                        Bookable,
                        DealerServicesResponse
                    >(
                        bookable,
                        bookable.dealerCode,
                        OSB_API_PATH.OSB_DEALER_SERVICES
                    )
                    .then(response => {
                        try {
                            transformedResponse.value = transformServiceResponse(
                                response
                            );
                            resolve(transformedResponse);
                        } catch (err) {
                            console.log(err);
                            transformedResponse.responseError.errorMessage =
                                'DEALER_SERVICES_CLIENT_TRANSFORMATION_ERROR: ' +
                                (err as Error)?.message;
                            reject(transformedResponse.responseError);
                        }
                    })
                    .catch(_error => {
                        transformedResponse.responseError = transformErrorResponse(
                            _error
                        );
                        reject(transformedResponse.responseError);
                        console.error(
                            'Rejected the promise - ',
                            transformedResponse.responseError
                        );
                    });
            }
        );
    }
}
